<style scoped>
</style>

<template>
    <div>
        <factory-order-list ref="orderList" :height="this.$tools.mainHeight() - 131" :excludeFields="'supplierName,creator,amount,paymentAmount,paymentStatus'" rights="'b,c,d'"  :canAdd="true"></factory-order-list>
    </div>
</template>

<script>
import FactoryOrderList from "./Factory-order-list.vue";

export default {
    components: { FactoryOrderList }
};
</script>